import { Input, Row, DateInput } from '@iqueue/ui-kit'
import { v4 as uuid } from 'uuid'
import moment from 'moment'
import { useState } from 'react'
import { t } from '../../hooks/useTranslate'
import PickSensorSerialNumber from '../../components/picker/PickSensorSerialNumber'

export default function VerificationUpsertForm({ model }) {
  const [verifiedAt, setVerifiedAt] = useState(model?.verifiedAt ? moment(model.verifiedAt) : undefined)

  return <div>
    <Input
      name={ 'id' }
      hidden
      value={ model.id }
    />

    <Row>
      <PickSensorSerialNumber
        size={ 12 }
        placeholder={ t('verificationPage.form.serialNumberPlaceholder') }
        value={ model?.sensor?.serialNumber }
      />
    </Row>


    <Row>
      <DateInput
        size={ 12 }
        name={ 'verifiedAt' }
        placeholder={ t('verificationPage.form.verifiedAtPlaceholder') }
        value={ verifiedAt }
        onChange={ (v) => {
          setVerifiedAt(v)
        } }
      />
    </Row>

    <Row>
      <Input
        size={ 12 }
        name={ 'description' }
        placeholder={ t('verificationPage.form.descriptionPlaceholder') }
        value={ model?.description }
      />
    </Row>
  </div>
}
